export const SET_LISTING= 'ACCESS-LOCATIONS/SET_LISTING'
export const DEL_LISTING= 'ACCESS-LOCATIONS/DEL_LISTING'